'use strict';

const tracking = require('./client');
const bootstrap = require('./bootstrap');
const pageEvents = require('./page-events');

if (typeof window !== 'undefined') {
    window.ShopChillBuyerTracking = Object.freeze({
        ...tracking,
        ...pageEvents,
    });

    if (typeof document !== 'undefined') {
        bootstrap.installBootstrap();
    }
}

module.exports = { ...tracking, ...bootstrap, ...pageEvents };
